import type { GetState, SetState, StoreApi } from 'zustand';
import type { State, ConsoleSlice } from '../../types';

export const createConsoleSlice: (
  set: SetState<State>,
  get: GetState<State>,
  api: StoreApi<State>,
) => ConsoleSlice = (set) => ({
  isConsoleOpen: false,
  scrollToTime: null,

  toggleConsole: () => set(({ isConsoleOpen }) => ({ isConsoleOpen: !isConsoleOpen })),
  openConsole: (scrollToTime?: number) => {
    set({
      isConsoleOpen: true,
      scrollToTime: scrollToTime && Number.isInteger(scrollToTime) ? scrollToTime : null,
    });
  },
});
